import { isBrowser } from '@phx-husky/browser-helpers';
import { useScreenRecognition } from '@phx-husky/use-screen-recognition';

const useBrowserScreen = () => {
  const { isMobile } = useScreenRecognition();

  const isMobileView = isBrowser() && isMobile;

  return { isMobileView };
};

export default useBrowserScreen;
